import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { FormattedMessage, intlShape, injectIntl } from 'react-intl';
import randomstring from 'uuid/v4';
import PropTypes from 'prop-types';

import { bindActionCreators } from 'redux';
import * as actions from '../../../../actions/client.actions';
import * as home from '../../../../actions/process.home.actions';

import TextField from '@material-ui/core/TextField';
import Switch from '@material-ui/core/Switch';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Hidden from '@material-ui/core/Hidden';

import FileBase64 from '../../../inputs/Logo';
import Loading from '../../../dialogs/loading';
import Error from '../../../dialogs/Error';
import Menu from '../Menu';
import Tree from './Tree';
import Licences from './Licenses';
import EditNode from './EditNode';
import Snackbar from '../../../labels/Snackbar';

import { TypeCameraIcon, BlueTickIcon } from '../../../../images/icons/WrapSvg';
import { tzList } from '../../../../const/tz.types';

// eslint-disable-next-line
import style from './_style.css';

function helperText(field, intl) {
    return field ? '' : intl.formatMessage({ id: 'required' });
}

function isOkEmail(value) {
    return value ? !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value) : false;
}

function toolbar(handleSummit) {
    return (
        <BlueTickIcon
            key="submmit-post-employee"
            className="hand"
            color="primary"
            onClick={handleSummit}
        />
    );
}

function searchTree(elements, id) {
    let i;
    let result = null;
    if (id === 'root') {
        return elements;
    } else {
        for (i = 0; result === null && i < elements.length; i++) {
            if (elements[i].id === id) {
                result = elements[i].hijos;
            }
            if (result === null && elements[i].hijos) result = searchTree(elements[i].hijos, id);
        }
        return result;
    }
}

function prepareTree(nodes) {
    return nodes.map((n) => {
        if (n.isNew) {
            delete n.id;
            delete n.isNew;
        }
        if (n.hijos && n.hijos.length > 0) n.hijos = prepareTree(n.hijos);
        return n;
    });
}

function findTree(elements, id) {
    let i;
    let result = null;
    if (id === 'root') {
        return elements;
    } else {
        for (i = 0; result === null && i < elements.length; i++) {
            if (elements[i].id === id) {
                result = elements[i];
            }
            if (result === null && elements[i].hijos) result = findTree(elements[i].hijos, id);
        }
        return result;
    }
}

class Customer extends React.Component {

    state = {
        id: randomstring(),
        client: undefined,
        nombre: '',
        email: '',
        contacto: '',
        observaciones: '',
        activo: true,
        idioma: 'es',
        tz: 'Europe/Madrid',
        evitarCron: false,
        evitarAlertas: false,
        error: '',
        hijos: [],
        selected: undefined,
        pending_changes: false,
        foto: undefined,
        isLoading: false,
        licencias: []
    };

    constructor(props) {
        super(props);
        if (props.id) {
            props.loadInfo(props.id);
        }
    }

    componentDidUpdate() {
        if (this.isCorrect() && this.state.pending_changes) {
            const tools = [toolbar(this.handleSummit)];
            this.props.setTools(tools);
        } else {
            this.props.setTools([]);
        }
    }

    componentWillUnmount() {
        this.props.setTools([]);
    }

    static getDerivedStateFromProps(props, state) {

        const { client, info } = props;
        if (client !== state.client && props.id) {
            const {
                id,
                nombre,
                email,
                observaciones,
                activo,
                idioma,
                tz,
                evitarCron,
                evitarAlertas,
                hijos,
                foto,
                licencias
            } = client;
            state.client = client;
            state.id = id;
            state.nombre = nombre ? nombre : '';
            state.email = email ? email : '';
            state.activo = activo === true ? true : false;
            state.idioma = idioma ? idioma : 'es';
            state.observaciones = observaciones ? observaciones : '';
            state.tz = tz ? tz : 'Europe/Madrid';
            state.evitarCron = evitarCron === true ? true : false;
            state.evitarAlertas = evitarAlertas === true ? true : false;
            state.hijos = hijos ? hijos : [];
            state.foto = foto;
            state.licencias = licencias ? licencias : [];
        } else if (!props.id && state.licencias.length === 0) {

            const temp = info.security  ? JSON.parse(JSON.stringify(info.security)).licencias : []; 
            state.licencias =  temp
                                ? temp.reduce((arr, l) => {
                                    if(l.quotable) {
                                        l.quota = -1;
                                        l.quotaUsed = "";
                                    }
                                    l.activo = l.forced ? true : false;
                                    arr.push(l)
                                    return arr;
                                }, [])
                                : [];

            return state;
        }
        return null;

    }

    handleBack = () => {
        if(this.props.lastLocation && this.props.lastLocation.pathname === "/user/login") {
            this.props.history.push("/");
        } else {
            this.props.history.goBack();
        }  
    }

    handleScroll = (e) => {
        this.props.setProminentToolBar(e.currentTarget.scrollTop === 0);
    }

    handleChange = (event) => {
        console.log(event.target);
        this.setState({ [event.target.name]: event.target.value, pending_changes: true });
    }

    handleChecked = (event) => {
        this.setState({
            [event.target.name]: event.target.checked,
            edit: true,
            pending_changes: true,
        });
    }

    handleDate = (date) => {
        this.setState({ fechaAlta: date, pending_changes: true });
    }

    handleClose = () => {
        this.setState({ error: '' });
    }

    isCorrect = () => {
        const { nombre, hijos } = this.state;
        return nombre && hijos && hijos.length > 0;
    }

    handleDrop = (arr) => {
        this.setState({ hijos: arr, pending_changes: true });
    }

    handleTreeEdit = (id, parentId) => {
        console.log(id, parentId);
        const node = findTree(this.state.hijos, parseInt(id, 10));
        console.log(node);
        this.setState({ selected: node, parentId: parentId, pending_changes: true });
    }

    handleTreeCron = (id, checked) => {
        const node = findTree(this.state.hijos, parseInt(id, 10));
        node.evitarCron = checked;
        this.setState({ hijos: this.state.hijos, pending_changes: true });
    }

    handleShow = (id, value) => {
        const node = findTree(this.state.hijos, parseInt(id, 10));
        node.ocultar = value;
        this.setState({ hijos: this.state.hijos, pending_changes: true });
    }

    handleCloseEdit = (node) => {
        if (node) {
            const arr = [...this.state.hijos];
            if (this.state.parentId === 'root') {
                const index = arr.map((f) => f.id).indexOf(parseInt(node.id, 10));
                arr.splice(index, 1, node);
                this.setState({
                    selected: undefined,
                    parentId: undefined,
                    hijos: arr,
                    pending_changes: true,
                });
            } else {
                const parent = searchTree(arr, parseInt(this.state.parentId, 10));
                if (parent) {
                    const index = parent.map((f) => f.id).indexOf(parseInt(node.id, 10));
                    parent.splice(index, 1, node);
                    this.setState({
                        selected: undefined,
                        parentId: undefined,
                        hijos: arr,
                        pending_changes: true,
                    });
                }
            }
        } else {
            this.setState({ selected: undefined, parentId: undefined });
        }
    }

    handleTreeDelete = (id, parentId) => {
        const arr = [...this.state.hijos];
        if (parentId === 'root') {
            const index = arr.map((f) => f.id).indexOf(parseInt(id, 10));
            arr.splice(index, 1);
            this.setState({ hijos: arr, pending_changes: true });
        } else {
            const parent = searchTree(arr, parseInt(parentId, 10));
            if (parent) {
                const index = parent.map((f) => f.id).indexOf(parseInt(id, 10));
                parent.splice(index, 1);
                this.setState({ hijos: arr, pending_changes: true });
            }
        }
    }

    handleTreeAdd = (text, parentId) => {
        const arr = [...this.state.hijos];
        const _new = {
            id: Math.round(Math.random() * 9999999),
            nombre: text,
            evitarCron: false,
            hijos: [],
            isNew: true,
            ocultar: false,
        };
        console.log(_new);
        if (parentId === 'root') {
            arr.push(_new);
            this.setState({ hijos: arr, pending_changes: true });
        } else {
            const parent = searchTree(arr, parseInt(parentId, 10));
            if (parent) {
                parent.push(_new);
                this.setState({ hijos: arr, pending_changes: true });
            }
        }
    }

    handleSummit = () => {
        const {
            id,
            nombre,
            email,
            observaciones,
            contacto,
            activo,
            idioma,
            tz,
            evitarCron,
            evitarAlertas,
            hijos,
            foto,
            licencias
        } = this.state;

        const client = {
            observaciones: observaciones,
            nombre: nombre,
            email: email,
            activo: activo,
            idioma: idioma,
            contacto: contacto,
            tz: tz,
            evitarCron: evitarCron,
            evitarAlertas: evitarAlertas,
            hijos: prepareTree(hijos),
            foto: foto,
            licencias: licencias
        };
        if (!this.props.id) {
            this.props
                .addClient(client)
                .then((r) => {
                    this.props.history.push('/manage/customers');
                })
                .catch((error) => {
                    console.error(error);
                    this.setState({ error: error.message, errorType: error.type });
                });
        } else {
            client.id = id;
            this.props
                .editClient(client)
                .then((r) => {
                    this.props.history.push('/manage/customers');
                })
                .catch((error) => {
                    console.error(error);
                    this.setState({ error: error.message, errorType: error.type });
                });
        }
    }

    Field = (field, name, intl, autoFocus = false, disable = false) => (
        <TextField
            autoFocus={autoFocus}
            fullWidth
            disabled={disable}
            id={name}
            name={name}
            required
            helperText={helperText(field, intl)}
            label={intl.formatMessage({ id: 'form_field_name_' + name })}
            className={'flex_full_row'}
            value={field}
            onChange={this.handleChange}
            margin="normal"
        />
    )

    handleErrorUpload = (error) => {
        this.setState({ isLoading: false, error: error });
    }

    isLoading() {
        this.setState({ isLoading: true });
    }

    async getFiles(file) {
        console.log(file);
        this.setState({ isLoading: false, foto: file, pending_changes: true });
    }

    render() {
        const { info } = this.props;
        
        if (
            info &&
            info.security &&
            info.security.totalPermits &&
            !info.security.totalPermits.some((f) => f === '20')
        ) {
            return <Error open id={'unauthorized_access'} handleClose={this.handleBack} />;
        } else {
            const {
                nombre,
                email,
                observaciones,
                contacto,
                activo,
                idioma,
                tz,
                evitarCron,
                evitarAlertas,
                error,
                errorType,
                hijos,
                selected,
                foto,
                licencias
            } = this.state;

            const { id, intl, clients_is_loading, clients_has_errored } = this.props;
            console.log(clients_has_errored.error)
            
            if (id && clients_has_errored.hasErrored) {
                return (
                    <Error open type={clients_has_errored.hasErrored} message={clients_has_errored.error} handleClose={this.handleBack} />
                );
            } else {
                return (
                    <div className={'flex_full_row bg_ice_blue'}>
                        {error && (
                            <Snackbar
                                open={true}
                                variant={ errorType ? errorType : "error" }
                                text={error}
                                onClose={this.handleClose}
                            />
                        )}
                        {id && clients_is_loading && <Loading open opacity />}
                        <Hidden xsDown>
                            <div
                                className={
                                    'flex_20 overflow_y_scroll padding_top_12 shadow_right_on_tablet bg_white'
                                }
                                onScroll={this.handleScroll}
                            >
                                <Menu code={4} />
                            </div>
                        </Hidden>

                        <div className={'flex_full'}>
                            <div className={'flex_full_column padding_bottom_9 height100'}>
                                <div
                                    className="flex_full overflow_y_scroll showbar "
                                    onScroll={this.handleScroll}
                                >
                                    <div
                                        className="width100 bg_ice_blue shadow"
                                        style={{ height: '128px' }}
                                    />

                                    <div className="flex_full_row center logo-user-menu">
                                        <div className="upload-btn-wrapper margin_top_9 center">
                                            {foto
                                                ? <div className="flex_auto_row boxShadow bg_white padding_borders_flat">
                                                    <img
                                                        src={foto}
                                                        width={250}
                                                        alt="Preview"
                                                    />
                                                </div>
                                                : <button className="btn bg_ice_blue btn_load_logo ">
                                                    <TypeCameraIcon width={16} heigth={16} color={'primary'} />
                                                </button>
                                            }
                                            <FileBase64
                                                multiple={true}
                                                onStart={this.isLoading.bind(this)}
                                                onDone={this.getFiles.bind(this)}
                                                onError={this.handleErrorUpload.bind(this)}
                                            />
                                        </div>


                                    </div>

                                    <div className="flex_full_column bg_white padding_borders">
                                        <TextField
                                            fullWidth
                                            id={'email'}
                                            name={'email'}
                                            error={isOkEmail(email)}
                                            helperText={
                                                isOkEmail(email)
                                                    ? intl.formatMessage({
                                                        id: 'email_format_error',
                                                    })
                                                    : ''
                                            }
                                            label={intl.formatMessage({
                                                id: 'form_field_name_email',
                                            })}
                                            className={'flex_full_row'}
                                            value={email}
                                            onChange={this.handleChange}
                                            margin="normal"
                                        />
                                        {this.Field(nombre, 'nombre', intl)}
                                        <TextField
                                            fullWidth
                                            id={'contacto'}
                                            name={'contacto'}
                                            label={intl.formatMessage({
                                                id: 'form_field_name_contact',
                                            })}
                                            className={'flex_full_row'}
                                            value={contacto}
                                            onChange={this.handleChange}
                                            margin="normal"
                                        />
                                        <TextField
                                            fullWidth
                                            id={'observaciones'}
                                            name={'observaciones'}
                                            label={intl.formatMessage({
                                                id: 'form_field_name_observation',
                                            })}
                                            className={'flex_full_row'}
                                            value={observaciones}
                                            onChange={this.handleChange}
                                            margin="normal"
                                        />
                                        <div className="flex_full_row margin_top_32 align_center">
                                            <div className="flex_full_column">
                                                <div className="flex_full_row c_dark_grey_blue barlow_medium_subtitle">
                                                    <FormattedMessage id="form_field_name_avoid_cron" />
                                                </div>
                                            </div>
                                            <div className="flex_auto_column">
                                                <Switch
                                                    name={'evitarCron'}
                                                    checked={evitarCron}
                                                    onChange={this.handleChecked}
                                                    value="evitarCron"
                                                    color="primary"
                                                />
                                            </div>
                                        </div>
                                        <div className="flex_full_row margin_top_32 align_center">
                                            <div className="flex_full_column">
                                                <div className="flex_full_row c_dark_grey_blue barlow_medium_subtitle">
                                                    <FormattedMessage id="form_field_name_avoid_alerts" />
                                                </div>
                                            </div>
                                            <div className="flex_auto_column">
                                                <Switch
                                                    name={'evitarAlertas'}
                                                    checked={evitarAlertas}
                                                    onChange={this.handleChecked}
                                                    value="evitarAlertas"
                                                    color="primary"
                                                />
                                            </div>
                                        </div>
                                        <div className="flex_full_row margin_top_32 align_center">
                                            <div className="flex_full_column">
                                                <div className="flex_full_row c_dark_grey_blue barlow_medium_subtitle">
                                                    <FormattedMessage id="form_field_name_active" />
                                                </div>
                                            </div>
                                            <div className="flex_auto_column">
                                                <Switch
                                                    name={'activo'}
                                                    checked={activo}
                                                    onChange={this.handleChecked}
                                                    value="activo"
                                                    color="primary"
                                                />
                                            </div>
                                        </div>
                                        <div className="flex_full_row margin_top_32">
                                            <FormControl className="flex_full_row">
                                                <InputLabel htmlFor="idioma">
                                                    <FormattedMessage id="form_field_name_language" />
                                                </InputLabel>
                                                <Select
                                                    fullWidth
                                                    value={idioma}
                                                    onChange={this.handleChange}
                                                    inputProps={{
                                                        name: 'idioma',
                                                        id: 'idioma-select',
                                                    }}
                                                >
                                                    <MenuItem value={'es'}>es</MenuItem>
                                                    <MenuItem value={'en'}>en</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </div>
                                        <div className="flex_full_row margin_top_32">
                                            <FormControl className="flex_full_row">
                                                <InputLabel htmlFor="tz">
                                                    <FormattedMessage id="form_field_name_tz" />
                                                </InputLabel>
                                                <Select
                                                    value={tz}
                                                    onChange={this.handleChange}
                                                    inputProps={{
                                                        name: 'tz',
                                                        id: 'tz-select',
                                                    }}
                                                >
                                                    {tzList.map((t) => (
                                                        <MenuItem
                                                            key={t.replace('/', '-')}
                                                            value={t}
                                                        >
                                                            {t}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </div>
                                        <Licences {...this.props} licencias={licencias} onChange={this.handleChange} />
                                        {hijos && (
                                            <Tree
                                                info={hijos}
                                                onDrop={this.handleDrop.bind(this)}
                                                onEdit={this.handleTreeEdit.bind(this)}
                                                onCron={this.handleTreeCron.bind(this)}
                                                onDelete={this.handleTreeDelete.bind(this)}
                                                onAdd={this.handleTreeAdd.bind(this)}
                                                onShow={this.handleShow.bind(this)}
                                            />
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        {selected && (
                            <EditNode
                                node={selected}
                                handleClose={this.handleCloseEdit.bind(this)}
                            />
                        )}
                    </div>
                );
            }
        }
    }
}

Customer.propTypes = {
    intl: intlShape.isRequired,
    client: PropTypes.object.isRequired,
    clients_has_errored: PropTypes.object.isRequired,
    clients_is_loading: PropTypes.bool.isRequired,
    clients: PropTypes.array.isRequired,
};

const mapStateToProps = (state) => {
    return {
        info: state.info,
        clients_has_errored: state.clients_has_errored,
        clients_is_loading: state.clients_is_loading,
        client: state.client,
        clients: state.clients,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(Object.assign({}, actions, home), dispatch);
};

Customer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(Customer);

Customer = withRouter(Customer);
Customer = injectIntl(Customer);

export default Customer;



// WEBPACK FOOTER //
// ./src/components/complex/manage/customer/Index.js